export const slots = ["P1", "P2", "P3", "P4", "P5"] as const;
